import styled from 'styled-components'

export const MaxButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin: 28px 0 9px;
`

export const BalanceLabel = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 16px;
`

export const StyledMaxButton = styled.button`
  background: ${({ theme }) => theme.colors.primaryMuted};
  border: none;
  border-radius: 20px;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  font-weight: 500;
  font-size: 10px;
  letter-spacing: 0.2px;
  line-height: 16px;
  margin-left: 10px;
  outline: none;
  padding: 1px 4px;
`
